import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ProductDetailNavigationState from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationState";
import { customerActions } from "@sonic/Store/GemecoState";
import { mappedAnchorLink } from "@sonic/Widgets/Common/AnchorNavigation";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<mappedAnchorLink, DispatchProp<customerActions>>;

export const DispatchChangeProductDetailNavigation: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductDetailNavigation/ChangeProductDetailNavigationState",
        parameter: props.parameter,
    });
};

export const chain = [DispatchChangeProductDetailNavigation];

const changeProductDetailNavigation = createHandlerChainRunner(chain, "ChangeProductDetailNavigationState");
export default changeProductDetailNavigation;
